export default __webpack_public_path__ + "5f2a2f236048660df440fb4e078f38b2.svg";